<h2 mat-dialog-title>Submit catalogue revision</h2>
<mat-dialog-content>
  <p class="hint mb-3">
    Saving sends this listing back to the review queue. It stays hidden from the public catalogue until approved again.
  </p>

  <form [formGroup]="form" class="resubmit-form">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Title</mat-label>
      <input matInput formControlName="title" maxlength="25" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Game</mat-label>
      <input
        matInput
        [formControl]="gameControl"
        [matAutocomplete]="gameAuto"
        (blur)="onGameBlur()"
        maxlength="50"
        required
      />
      <mat-autocomplete
        #gameAuto="matAutocomplete"
        [displayWith]="displayGame.bind(this)"
        (optionSelected)="onAutocompleteSelected($event)"
      >
        <mat-option *ngFor="let game of filteredGames$ | async" [value]="game">
          {{ game.name }}
        </mat-option>
        <mat-option *ngIf="showAddOption" [value]="pendingAddLabel">
          Add "{{ pendingAddLabel }}"
        </mat-option>
      </mat-autocomplete>
      <mat-hint *ngIf="createNewGame">New game name — added after approval</mat-hint>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Description</mat-label>
      <textarea matInput formControlName="description" rows="4" maxlength="1024"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Notes for reviewer</mat-label>
      <textarea matInput formControlName="notes" rows="2" maxlength="1024"></textarea>
      <mat-hint>Optional — only the catalogue reviewer can see this</mat-hint>
    </mat-form-field>

    <mat-checkbox
      class="replace-toggle mb-2"
      [checked]="replaceStructure"
      (change)="onReplaceToggle($event.checked)"
    >
      Also replace signup layout (emojis, limits, …)
    </mat-checkbox>

    <ng-container *ngIf="replaceStructure">
      <p class="hint mb-2">
        Pick a server template you already edited. Import this listing first if you need a working copy.
      </p>
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Server</mat-label>
        <mat-select
          formControlName="source_guild_id"
          (selectionChange)="onGuildSelected($event.value)"
        >
          <mat-option *ngFor="let guild of guilds" [value]="guild.id">{{ guild.name }}</mat-option>
        </mat-select>
        <mat-hint *ngIf="!guilds.length">No servers where you can manage templates.</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Signup template</mat-label>
        <mat-select formControlName="source_template_id" [disabled]="!form.value.source_guild_id">
          <mat-option *ngFor="let tpl of guildTemplates" [value]="tpl.id">{{ tpl.name }}</mat-option>
        </mat-select>
        <mat-hint *ngIf="loadingGuildTemplates">Loading templates…</mat-hint>
        <mat-hint *ngIf="!loadingGuildTemplates && form.value.source_guild_id && !guildTemplates.length">
          This server has no custom signup templates.
        </mat-hint>
      </mat-form-field>
    </ng-container>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close [disabled]="submitting">Cancel</button>
  <button
    mat-flat-button
    color="primary"
    [disabled]="submitting || form.invalid"
    (click)="submit()"
  >
    Submit for review
  </button>
</mat-dialog-actions>
